import React from 'react'
// libs
import { isMobile } from 'react-device-detect'

/** hook which scroll to extra px when scroll reaches container border for activating mobile scroll */
export const useMobileScroll = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const container = scrollRef.current

    if (!container || !isMobile) {
      return
    }

    container.style.overscrollBehavior = 'none'
    container.scrollLeft = 1

    const handleScroll = () => {
      if (!container) return

      if (container.scrollLeft <= 0) {
        container.scrollLeft = 1
      } else if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
        container.scrollLeft -= 1
      }
    }

    container.addEventListener('scroll', handleScroll, { passive: true })
    return () => container.removeEventListener('scroll', handleScroll)
  }, [])

  return scrollRef
}
